// extracted by mini-css-extract-plugin
module.exports = {"control":"CheckoutComplete_control__2WHSD","row":"CheckoutComplete_row__2o_8Z","col":"CheckoutComplete_col__3Rsdo"};